import { hasUserValidCompanyRole } from "@utils/access-control/company/company-access-control";
/**
 * Whether the current user should be prevented from changing their own project role.
 * A Project Admin (RESOURCE_ADMIN) cannot downgrade themselves unless they are also
 * a Company Admin (COMPANY_EXECUTIVE).
 */
export function isProjectAdminSelfDowngrade({
  currentUser,
  memberIdentity,
  memberProjectRole
}) {
  const isCompanyAdmin = hasUserValidCompanyRole({
    currentUser,
    requiredCompanyRoles: ["COMPANY_EXECUTIVE"]
  });
  const isCurrentUserProjectAdmin = memberIdentity === currentUser?.identity && memberProjectRole === "RESOURCE_ADMIN";
  return isCurrentUserProjectAdmin && !isCompanyAdmin;
}